import buildReducer from "./build-reducer";
import { DATABASE_UPDATE } from "../actions/database";
import { fromJS, Map } from "immutable";
import { TOURNAMENT_CHAT_APPEND } from "../actions/tournament-chat";

let reducers = {};

reducers[DATABASE_UPDATE] = (state, { tables: { tournament_chats: chats } }) => {
  if (chats === undefined) {
    return state;
  }

  return state.merge(chats.reduce((byTournament, chat) => {
    if (byTournament.has(chat.tournament_id)) {
      return byTournament.set(chat.tournament_id, byTournament.get(chat.tournament_id).push(fromJS(chat)));
    }
    return byTournament.set(chat.tournament_id, fromJS([chat]));
  }, Map()));
};
reducers[TOURNAMENT_CHAT_APPEND] = (state, { tables: { tournament_chats: chats } }) => {
  if (chats === undefined) {
    return state;
  }

  return chats.reduce((byTournament, chat) => {
    if (byTournament.has(chat.tournament_id)) {
      var forTourney = byTournament.get(chat.tournament_id);
      // don't add duplicate chats
      // this could be slow on tournaments with lots of chats
      // this is a temporary band-aid while the server is sending duplicates
      // if we can't fix the server, we might have to store them by id
      if (forTourney.find((c) => c.get("id") === chat.id)) {
        return byTournament;
      }
      return byTournament.set(chat.tournament_id, forTourney.push(fromJS(chat)));
    }
    return byTournament.set(chat.tournament_id, fromJS([chat]));
  }, state);
};

export default buildReducer(Map(), reducers);
